import { yup } from '@guiker/yup-util'

export const pictureSchema = yup.object({})
